/**
 * Block factory helper function
 *
 * @param  {string}   blockName  Block name.
 * @param  {Function} BlockClass Block class.
 * @return {void}
 */
export default (blockName, BlockClass) => {
	const blocks = document.querySelectorAll(`.block.${blockName}`);

	for (const block of blocks) {
		new BlockClass(block);
	}
};
